import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { FaEnvelopeOpen, FaEnvelope, FaTrash, FaTimes } from 'react-icons/fa';

export default function AdminMessages() {
  const { token } = useAuth();
  const headers = { Authorization: `Bearer ${token}` };
  const [messages, setMessages] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => axios.get('/api/contact', { headers }).then(r => setMessages(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const openMsg = async (msg) => {
    setSelected(msg);
    if (!msg.is_read) {
      await axios.patch(`/api/contact/${msg.id}/read`, {}, { headers });
      setMessages(ms => ms.map(m => m.id === msg.id ? { ...m, is_read: 1 } : m));
    }
  };

  const deleteMsg = async (id) => {
    if (!window.confirm('Bu mesajı silmek istediğinize emin misiniz?')) return;
    await axios.delete(`/api/contact/${id}`, { headers });
    if (selected?.id === id) setSelected(null);
    load();
  };

  const unreadCount = messages.filter(m => !m.is_read).length;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-primary">Mesajlar</h1>
        <p className="text-gray-500 text-sm">{messages.length} mesaj{unreadCount > 0 && `, ${unreadCount} okunmamış`}</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        {messages.length === 0 ? (
          <div className="text-center py-16 text-gray-400">
            <FaEnvelope size={48} className="mx-auto opacity-20 mb-3" />
            <p>Henüz mesaj yok</p>
          </div>
        ) : (
          <div className="divide-y">
            {messages.map(msg => (
              <div
                key={msg.id}
                onClick={() => openMsg(msg)}
                className={`flex items-start gap-4 px-5 py-4 cursor-pointer hover:bg-gray-50 transition-colors ${!msg.is_read ? 'bg-blue-50/60' : ''}`}
              >
                <div className={`mt-1 flex-shrink-0 ${!msg.is_read ? 'text-secondary' : 'text-gray-300'}`}>
                  {msg.is_read ? <FaEnvelopeOpen size={16} /> : <FaEnvelope size={16} />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2 mb-0.5">
                    <span className={`text-sm ${!msg.is_read ? 'font-semibold text-gray-800' : 'font-medium text-gray-600'}`}>{msg.name}</span>
                    <span className="text-xs text-gray-400 flex-shrink-0">{new Date(msg.created_at).toLocaleDateString('tr-TR')}</span>
                  </div>
                  <p className="text-xs text-gray-500 truncate">{msg.subject || msg.message}</p>
                </div>
                <button
                  onClick={e => { e.stopPropagation(); deleteMsg(msg.id); }}
                  className="flex-shrink-0 p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                >
                  <FaTrash size={13} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Message Detail Modal */}
      {selected && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-lg shadow-2xl">
            <div className="flex items-center justify-between px-6 py-4 border-b">
              <h3 className="font-semibold text-gray-700">{selected.subject || 'Mesaj Detayı'}</h3>
              <button onClick={() => setSelected(null)} className="text-gray-400 hover:text-gray-600"><FaTimes /></button>
            </div>
            <div className="p-6 space-y-4">
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="text-gray-400 block text-xs mb-0.5">Gönderen</span>
                  <span className="font-medium text-gray-700">{selected.name}</span>
                </div>
                <div>
                  <span className="text-gray-400 block text-xs mb-0.5">Tarih</span>
                  <span className="text-gray-700">{new Date(selected.created_at).toLocaleString('tr-TR')}</span>
                </div>
                <div>
                  <span className="text-gray-400 block text-xs mb-0.5">E-posta</span>
                  <a href={`mailto:${selected.email}`} className="text-secondary hover:underline">{selected.email}</a>
                </div>
                {selected.phone && (
                  <div>
                    <span className="text-gray-400 block text-xs mb-0.5">Telefon</span>
                    <a href={`tel:${selected.phone}`} className="text-secondary hover:underline">{selected.phone}</a>
                  </div>
                )}
              </div>
              <div className="bg-gray-50 rounded-xl p-4">
                <span className="text-gray-400 text-xs mb-2 block">Mesaj</span>
                <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">{selected.message}</p>
              </div>
              <div className="flex gap-3">
                <a href={`mailto:${selected.email}?subject=Re: ${selected.subject || ''}`}
                  className="flex-1 btn-primary justify-center py-2.5 text-sm">
                  Yanıtla
                </a>
                <button onClick={() => { deleteMsg(selected.id); setSelected(null); }}
                  className="px-4 py-2.5 bg-red-50 text-red-600 hover:bg-red-100 rounded-lg text-sm font-medium transition-colors">
                  <FaTrash />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
